import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Drawer.module.css";

const Drawer = ({
    drawer,
    setDrawer,
    loggedIn,
    subscribed,
    actionLoading,
    onSubscribe,
    onUnsubscribe,
    onLogin,
    onLogout,
    onWatchNow,
}) => {
    const navigate = useNavigate();

    const handleNavigate = (action) => {
        setDrawer(false);
        action();
    };

    const subscribeLabel = subscribed ? "Unsubscribe" : "Subscribe";
    const authLabel = loggedIn ? "Logout" : "Login";

    const handleSubscribeClick = () => {
        if (subscribed) {
            handleNavigate(onUnsubscribe);
            return;
        }
        handleNavigate(onSubscribe);
    };

    const handleAuthClick = () => {
        if (loggedIn) {
            handleNavigate(onLogout);
            return;
        }
        handleNavigate(onLogin);
    };

    return (
        <div
            className={`${classes.drawer} ${drawer && classes.show}`}
            onClick={() => setDrawer(false)}
        >
            <div
                className={classes.drawer_container}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={classes.menu_items}>
                    <button
                        className={classes.menu_item}
                        onClick={() => handleNavigate(() => navigate("/"))}
                    >
                        Home
                    </button>
                    <div className={classes.divider}></div>

                    <button
                        className={classes.menu_item}
                        onClick={handleSubscribeClick}
                        disabled={actionLoading}
                    >
                        {actionLoading ? "Please wait..." : subscribeLabel}
                    </button>
                    <div className={classes.divider}></div>

                    <button
                        className={classes.menu_item}
                        onClick={handleAuthClick}
                        disabled={actionLoading}
                    >
                        {authLabel}
                    </button>
                    <div className={classes.divider}></div>

                    <button
                        className={classes.menu_item}
                        onClick={() => handleNavigate(onWatchNow)}
                    >
                        Categories
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Drawer;
